export default __webpack_public_path__ + "static/media/pexels-faaiq-ackmerd-1025469.ff201e03.jpg";